import React, { useState, useEffect, useContext } from 'react'
import { Form, Typography, Result, Skeleton } from 'antd'
import { Link } from 'react-router-dom';
import { appContext } from "../../AppContext";
//Utill fields
import SubmitButton from './../../Utils/SubmitButton';
import PasswordField from './../../Utils/PasswordField';
//Hooks
import { useTranslation } from 'react-i18next'
import { useErrorMessage } from './../../Utils/Hooks/useErrorMessage'
import { useFetch } from './../../Utils/Hooks/useFetch'
import { useFormLayout } from './../../Utils/Hooks/useFormLayout'

const { Title, Text } = Typography; 
const size = "large"

export default function Reset()
{
    // eslint-disable-next-line 
    const [appState, appDispatch] = useContext(appContext);
    const { t } = useTranslation(['login'])     
    const [isLoading, setIsLoading] = useState(true);
    const [isChangePasswordLoading, setIsChangePasswordLoading] = useState(false);
    const [isValidForgotId, setIsValidForgotId] = useState(false);
    const [isPasswordChanged, setIsPasswordChanged] = useState(false);
    const [doFetch, FetchType] = useFetch();
    const [errorMessage, setErrorMessage] = useErrorMessage('')
    const layout = useFormLayout(size, "vertical");
    const [isPasswordValidated, setIsPassWordValidated] = useState(false)
    const returnUrl = new URLSearchParams(window.location.search).get("returnurl")
    const forgotId = new URLSearchParams(window.location.search).get("forgotid")

    useEffect(() => {
        var uri_enc = encodeURIComponent(forgotId);
        doFetch("/Forgot/validate?forgotId=" + uri_enc)
            .then((response) => onValidatedLoaded(response.isSuccess))

        function onValidatedLoaded(isSuccess) {
            if(isSuccess){
                setIsValidForgotId(true)
            }
            setIsLoading(false)  
        }

        
        if(returnUrl != null) {
            appDispatch({ type: "SETRETURNURL", payload: returnUrl })
        }

    }, // eslint-disable-next-line 
    [])

    if(isLoading)
    {
        return (
            <Skeleton title={false} paragraph={{rows:1}}/>
        )
    }

    if(!isValidForgotId || forgotId === null)
    {
         return (
            <>
                <Result
                    status="500"
                    title={t("resetPassword.invalidTitle")}
                    subTitle={t("resetPassword.invalidSubtitle")}
                />
                <Link to={""}> {t("forgotPassword.backToLogin")} </Link>
            </>
        )
    }
    if(isPasswordChanged)
    {
        return (
            <>
                <Result
                    status="success"
                    title={t("resetPassword.successTitle")}
                    subTitle={t("resetPassword.successSubtitle")}
                />
                <Link to={"/"}> {t("forgotPassword.backToLogin")} </Link>
            </>
        )
    }

    return (
        <div>
            <Title level={1} >{t("resetPassword.title")}</Title>

            <Form             
                {...layout}
                name="basic"
                onFinish={onSubmitClick} >
 
                    <PasswordField 
                        input="password" 
                        size={size} 
                        label={t("login.password")}      
                        isRequired={true} 
                        isRequiredText={t("login.passwordRequired")} 
                        isLoading={isLoading}
                        setPasswordPolicyTracker={true}
                        validatePassword={validatePassword}/>
                     
                    <PasswordField 
                        input="confirmPassword" 
                        size={size} 
                        label={t("login.confirmPassword")}      
                        isRequired={true} 
                        isRequiredText={t("login.passwordRequired")} 
                        isLoading={isLoading}/> 

                    <SubmitButton 
                        isLoading={isLoading} 
                        isDoingAction={isChangePasswordLoading} 
                        originalText={t("resetPassword.submit")} 
                        loadingText={t("resetPassword.loading")} 
                        size={size}
                        disabled={!isPasswordValidated}
                    />

                    <Text type="danger">{errorMessage}</Text>
            </Form>
        </div>
    )

    function validatePassword(value) {
        setIsPassWordValidated(value)
    }

    function onSubmitClick(values)
    {
        if(!isPasswordValidated)
        {
            setErrorMessage("error.password_missing_policies")
            return;
        }

        if(values.password !== values.confirmPassword)
        {
            setErrorMessage("error.password_not_the_Same")
            return;
        }

        setIsChangePasswordLoading(true);

        const body = { 
            password: values.password,
            forgotId: forgotId
        };

        doFetch(`/Forgot/reset`, FetchType.POST, body)
            .then((response) => onResetFetchLoaded(response.isSuccess, response.result))

        function onResetFetchLoaded(isSuccess, result) {

            isSuccess ? setIsPasswordChanged(true) : setErrorMessage(result)
    
            setIsChangePasswordLoading(false)
        }
    }
}